import React from 'react';
import ReactDOM from 'react-dom/client';

// Figtree is the Sunrise corporate typeface (400 regular / 700 bold). Bundled
// locally rather than fetched from Google Fonts so there is no third-party
// request and no layout shift.
import '@fontsource/figtree/400.css';
import '@fontsource/figtree/700.css';

import './index.css';
import './sidebar.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
